var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCharacterCouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8005 11.0665C10.7812 11.0665 9.13379 12.7139 9.13379 14.7332V19.7665C9.13379 21.1472 8.0145 22.2665 6.63379 22.2665C5.25308 22.2665 4.13379 21.1472 4.13379 19.7665V14.7332C4.13379 9.95249 8.01974 6.06653 12.8005 6.06653H55.8671C60.6478 6.06653 64.5338 9.95248 64.5338 14.7332V19.7665C64.5338 21.1472 63.4145 22.2665 62.0338 22.2665C60.6531 22.2665 59.5338 21.1472 59.5338 19.7665V14.7332C59.5338 12.7139 57.8864 11.0665 55.8671 11.0665H12.8005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.332 8.56653C35.7127 8.56653 36.832 9.68582 36.832 11.0665V60.3332C36.832 61.7139 35.7127 62.8332 34.332 62.8332C32.9513 62.8332 31.832 61.7139 31.832 60.3332V11.0665C31.832 9.68582 32.9513 8.56653 34.332 8.56653Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.501 60.3333C20.501 58.9525 21.6203 57.8333 23.001 57.8333H41.601C42.9817 57.8333 44.101 58.9525 44.101 60.3333C44.101 61.714 42.9817 62.8333 41.601 62.8333H23.001C21.6203 62.8333 20.501 61.714 20.501 60.3333Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0986 34.4666C43.0986 33.0858 44.2179 31.9666 45.5986 31.9666H68.9653C72.7793 31.9666 75.8653 35.0525 75.8653 38.8666V41.5332C75.8653 42.9139 74.746 44.0332 73.3653 44.0332C71.9846 44.0332 70.8653 42.9139 70.8653 41.5332V38.8666C70.8653 37.8139 70.0179 36.9666 68.9653 36.9666H45.5986C44.2179 36.9666 43.0986 35.8473 43.0986 34.4666Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5996 33.7334C54.9803 33.7334 56.0996 34.8527 56.0996 36.2334V71.4334C56.0996 72.8141 54.9803 73.9334 53.5996 73.9334C52.2189 73.9334 51.0996 72.8141 51.0996 71.4334V36.2334C51.0996 34.8527 52.2189 33.7334 53.5996 33.7334Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9678 71.4336C43.9678 70.0529 45.0871 68.9336 46.4678 68.9336H60.7344C62.1152 68.9336 63.2344 70.0529 63.2344 71.4336C63.2344 72.8143 62.1152 73.9336 60.7344 73.9336H46.4678C45.0871 73.9336 43.9678 72.8143 43.9678 71.4336Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterCouter);
export default __webpack_public_path__ + "static/media/characterCouter.9dd14d69.svg";
export { ForwardRef as ReactComponent };